import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { env } from "../../env";
import axios from "axios";

const AddNewCouponPopUpComponent = ({customerId, currentCoupon, sendModalCloseDataFromChild}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [buttonLoading, setButtonLoading] = useState(false);
   
    const hangleModalClose = (e) => {
        e.preventDefault();
        sendModalCloseDataFromChild(false);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setButtonLoading(true);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        const requestData = {
            "CustomerId": customerId,
            "SeriesId": currentCoupon.SeriesId
        }
        axios.post(baseUrl+"/api/OfflineSync/AssignCouponToCustomer", requestData, {
            headers : {
                "Accept" : "Application/json",
                "Content-Type" : "Application/json",
                "Authorization" : `Bearer ${token}`
            }
        }).then((response) => {
            navigate(`/profiles/detail/${customerId}`);
            setButtonLoading(false);
        }).catch((error) => {
            console.log(error);
            setButtonLoading(false);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    
    return (
        <div className="fixed z-40 overflow-y-auto top-0 w-full left-0 h-full">
            <div className="flex items-center justify-center min-height-100vh px-4 py-8 text-center sm:block sm:p-0 h-full">
                <div className="fixed inset-0 transition-opacity">
                    <div className="absolute inset-0 bg-gray-900 opacity-75" />
                </div>
                <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                <div className="flex flex-col justify-center sm:justify-normal items-center sm:inline-block space-y-3 sm:space-y-1 align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-xs w-full p-4" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                    <div className="bg-white space-y-2 sm:space-y-3">
                        <div className="flex justify-between items-center">
                            <div className="font-semibold sm:text-lg first-letter:capitalize">{ t('are you sure to add')}?</div>
                            <div className="hidden sm:block cursor-pointer" onClick={(e) => hangleModalClose(e)}>
                                <img src="../../../assets/icons/modal-cross.svg" alt="cross" />
                            </div>
                        </div>
                    </div>
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className="space-y-4">
                            <div className="text-light-400 text-sm">
                                {currentCoupon.BatchName}
                            </div>
                            {/* form button */}
                            <div className="flex justify-evenly sm:justify-end items-center sm:space-x-4">
                                <button onClick={(e) => hangleModalClose(e)} type="button" className="text-center px-4 font-medium py-1.5 text-light-400 bg-white border border-light-400 rounded-lg tracking-wide capitalize text-sm">{ t('no') }</button>
                                <button type={buttonLoading ? "button" : "submit"} className={(buttonLoading ? "cursor-wait" : "cursor-pointer") + " text-white bg-blue-normal border-blue-normal text-center px-4 text-sm font-medium py-1.5 border rounded-lg tracking-wide capitalize"}>{buttonLoading? (t('Please wait')+'...') : t('yes') }</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AddNewCouponPopUpComponent;